export default __webpack_public_path__ + "static/about-rocketmakers-e130c9aa1bfcc99a458d3a523a7fabb0.png";